import clsx from 'clsx'
import React from 'react'

import { getMoneyClasses, getMoneyText } from 'components/members/utils'
import { membersTransactions } from 'rails_routes'
import { Table } from 'slab'
import { conditionallyLocalizeDate } from 'utils'
import { type BalanceTransaction } from 'utils/web_api.schemas'
import { useWindowLocation } from 'utils/windowLocation'

import { TransactionCategoryBadge } from '../TransactionCategoryBadge/TransactionCategoryBadge'

export const TransactionRow: React.FC<{ transaction: BalanceTransaction }> = ({ transaction }) => {
  const { assign } = useWindowLocation()

  return (
    <Table.Row
      key={transaction.id}
      onClick={() => assign(membersTransactions.show({ id: transaction.id }))}
      accessibleLabel={`View details for transaction ${transaction.id}`}
    >
      <Table.Cell>
        <span className='body text-main text-nowrap'>
          {conditionallyLocalizeDate(
            new Date(transaction.date)
          )}
        </span>
      </Table.Cell>
      <Table.Cell>
        <span className='body text-main'>
          {transaction.description}
        </span>
      </Table.Cell>
      <Table.Cell>
        <TransactionCategoryBadge
          category={transaction.category}
        />
      </Table.Cell>
      <Table.Cell>
        <div className='flex justify-end'>
          <span className={getMoneyClasses(transaction.amount)}>
            {getMoneyText(transaction.amount)}
          </span>
        </div>
      </Table.Cell>
    </Table.Row>
  )
}

export const MobileTransactionRow: React.FC<{ transaction: BalanceTransaction }> = ({ transaction }) => {
  const { assign } = useWindowLocation()

  return (
    <div
      className={clsx(
        'flex flex-col w-full gap-2 py-3 border-t border-gray-200',
        {
          'cursor-pointer': transaction.source_id,
        }
      )}
      onClick={() => assign(membersTransactions.show({ id: transaction.id }))}
      aria-label={`View details for transaction ${transaction.id}`}
    >
      <div className='flex flex-row w-full justify-between items-start'>
        <div className='flex flex-col gap-1'>
          <div className='body-bold text-main'>
            {transaction.description}
          </div>
          <div className='body-sm text-gray-500'>
            {conditionallyLocalizeDate(new Date(transaction.date))}
          </div>
        </div>
        <div className={getMoneyClasses(transaction.amount)}>
          {getMoneyText(transaction.amount)}
        </div>
      </div>
      <TransactionCategoryBadge category={transaction.category} />
    </div>
  )
}
